export default __webpack_public_path__ + "static/media/credit-card.ba1e7c3b.svg";